/**
 * Settings → Git credentials tab, and the section's landing view — it is what
 * people open Settings to do. Applied to new workspaces by default.
 */

import type { ReactElement } from 'react';
import { SettingsForm } from '@features/settings';

export function GitCredentialsTab(): ReactElement {
  return (
    <>
      <p className="section-description">
        These settings will be applied to new workspaces by default.
      </p>
      <SettingsForm />
    </>
  );
}
